export default {
  stripe_error_title: 'Erreur lors du paiement',
  stripe_error_default_text: 'Une erreur est survenue. Avez vous renseigné une carte bancaire valide ?',
  error_codes: {
    incorrect_number: 'Le numéro de carte est incorrect.',
    invalid_number: 'Le numéro de carte n’est pas un numéro de carte valide.',
    invalid_expiry_month: 'Le mois d’expiration de la carte n’est pas valide.',
    invalid_expiry_year: 'L’année d’expiration de la carte n’est pas valide.',
    invalid_cvc: 'Le code de sécurité de la carte n’est pas valide.',
    expired_card: 'La carte a expiré.',
    incorrect_cvc: 'Le code de sécurité de la carte est incorrect.',
    incorrect_zip: 'La validation du code postal de la carte a échoué.',
    card_declined: 'La carte a été refusée.',
    missing: 'Aucun client associé à cette carte',
    insufficient_funds: 'La carte a été refusée pour fonds insuffisants. Veuillez vérifier si vos plafonds n\'ont pas été dépassés et réessayer, ou changer de moyen de paiement.',
    processing_error: 'Une erreur est survenue lors du contrôle de la carte.',
    authentication_required: 'Une authentification 3DSecure est nécessaire pour réaliser le paiement.',
    rate_limit: 'Une erreur est survenue en raison d\'un trop grand nombre de requêtes vers le serveur. Veuillez nous contacter si vous rencontrez cette erreur systématiquement.',
  },
};
